<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                {{'Take the card'|translate}} {{ card.cardNumber }}
            </span>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar style="font-size: 36px; color: red; font-weight: bold;">
        {{'Take the card from customer!'|translate}}
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">
        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close(form)"
                aria-label="Confirm">
            {{'Confirm'|translate}}
        </button>
    </div>
</div>
